import React from "react";
import { Box, Text } from "@chakra-ui/react-v3";
import { Switch } from "@chakra-ui/react";

export interface OneMedicalFilterToggleProps {
  isEnabled: boolean;
  onToggle: (enabled: boolean) => void;
}

/**
 * Floating card with toggle for One Medical filtering functionality.
 * Only shows in V2 patient overview.
 */
export function OneMedicalFilterToggle({ isEnabled, onToggle }: OneMedicalFilterToggleProps) {
  return (
    <Box
      position="fixed"
      right="6"
      bottom="6"
      zIndex="1000"
      bg={isEnabled ? "orange.50" : "blue.50"}
      border="2px"
      borderColor={isEnabled ? "orange.400" : "blue.400"}
      borderRadius="lg"
      p="4"
      boxShadow="xl"
      minW="200px"
      _dark={{
        bg: isEnabled ? "orange.900" : "blue.900",
        borderColor: isEnabled ? "orange.300" : "blue.300",
      }}
    >
      <Box display="flex" alignItems="center" justifyContent="space-between" gap="3">
        <Text
          fontSize="sm"
          fontWeight="semibold"
          color={isEnabled ? "orange.700" : "blue.700"}
          _dark={{ color: isEnabled ? "orange.200" : "blue.200" }}
        >
          Filter out OM data
        </Text>
        <Switch
          size="md"
          isChecked={isEnabled}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => onToggle(e.target.checked)}
          colorScheme={isEnabled ? "orange" : "blue"}
        />
      </Box>
    </Box>
  );
}
